export default "__VITE_ASSET__B4W8EK0S__"